import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const OperatorProfileField = ({
    darkMode,
    errors,
    touched,
    fieldName,
    label,
    placeholder,
    errorMessage,
    tooltipLabel,
    tooltipAriaLabel,
    isRequired = true,
    ...props
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors[fieldName] && touched[fieldName]}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired={isRequired}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        {label}
                    </FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id={fieldName}
                            name={fieldName}
                            placeholder={placeholder}
                            validate={
                                errorMessage
                                    ? (value) => !value && errorMessage
                                    : undefined
                            }
                            {...props}
                        />
                        <FormErrorMessage>{errors[fieldName]}</FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={tooltipLabel}
                        ariaLabel={tooltipAriaLabel}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OperatorProfileField;
